import FieldType from "@/utils/constants/FieldType.ts";
import StringValueFormatter from "@/utils/UIConstants/AGGridEditViewValueFormatters/StringValueFormatter.ts";
import AbsEditViewValueFormatter from "@/utils/UIConstants/AGGridEditViewValueFormatters/AbsEditViewValueFormatter.ts";
import BigDecimalValueFormatter from "@/utils/UIConstants/AGGridEditViewValueFormatters/BigDecimalValueFormatter.ts";
import IntegerValueFormatter from "@/utils/UIConstants/AGGridEditViewValueFormatters/IntegerValueFormatter.ts";
import DateValueFormatter from "@/utils/UIConstants/AGGridEditViewValueFormatters/DateValueFormatter.ts";
import DateTimeValueFormatter from "@/utils/UIConstants/AGGridEditViewValueFormatters/DateTimeValueFormatter.ts";
import TimeValueFormatter from "@/utils/UIConstants/AGGridEditViewValueFormatters/TimeValueFormatter.ts";
import BooleanValueFormatter from "@/utils/UIConstants/AGGridEditViewValueFormatters/BooleanValueFormatter.ts";
import FileUploaderValueFormatter from "@/utils/UIConstants/AGGridEditViewValueFormatters/FileUploaderValueFormatter.ts";

export default class ValueFormatterFactory {
  static fromFieldType(type?: FieldType): AbsEditViewValueFormatter {
    if (!type)
      return StringValueFormatter.instance();
    switch (type) {
      case FieldType.Link:
      case FieldType.Email:
      case FieldType.Color:
      case FieldType.Text:
      case FieldType.BigText:
      case FieldType.LongToken:
      case FieldType.FieldID:
      case FieldType.LatLng:
      case FieldType.PhoneNumber:
        return StringValueFormatter.instance();
      case FieldType.Decimal:
        return BigDecimalValueFormatter.instance();
      case FieldType.Long:
      case FieldType.Integer:
        return IntegerValueFormatter.instance();
      case FieldType.Boolean:
        return BooleanValueFormatter.instance();
      case FieldType.Date:
        return DateValueFormatter.instance();
      case FieldType.DateAndTime:
        return DateTimeValueFormatter.instance();
      case FieldType.Time:
        return TimeValueFormatter.instance();
      case FieldType.Binary:
        return FileUploaderValueFormatter.instance();
      // case FieldType.EntityType:
      // case FieldType.Enum:
      //   return (ValueFormatter<T>)
      //   TranslatorValueFormatter.instance();
      // case FieldType.Measures:
      //   return (ValueFormatter<T>)
      //   MeasuresFormatter.instance();
      default:
        return StringValueFormatter.instance();
    }
  }
}
